module.exports = __webpack_public_path__ + "resources/img/sp_appguard.ec11ec997c40ee83ef6fedb30a561a5a.png";